import { cloneDeep } from 'lodash'

const customerState = {
  id: '',             // 塾ID
  clientCode: '',     // お客様No
  name: '',           // 貴塾名
  postalCode: '',     // 郵便番号
  address: '',        // 住所
  tel: '',            // 代表電話番号
  mail: '',           // メールアドレス
  enChargePerson: '', // EN担当者
  logoFilename: '',   // ロゴ画像ファイル名
  logoFile: new File([], '', {}),       // ロゴファイル
  logoImage: '',      // ロゴ画像（表示用）
  invoiceType: '',    // 請求タイプ
  startTime: ''       // 利用開始時期
}

const classroomState = {
  name: '',         // 教室名
  tel: '',          // 教室電話番号
  chargePerson: '', // 教室担当者
  mail: '',         // 教室メールアドレス
  startTime: '',    // 利用開始時期
}

const searchState = {
  clientCode: '', // お客様No
  tel: ''         // 塾代表電話番号
}

const cancelState = {
  selectedReason: [],  // 解約理由
  message: '',         // 解約理由その他
  name: '',            // 解約申請者
}

export default {
  namespaced: true,

  state: {
    formComponent: '',                         // フォーム種類： 新規 or 教室追加 or 解約
    searchForm: cloneDeep(searchState),        // 塾検索フォーム
    searchFormValid: true,                     // 塾検索フォームに入力不備がないか
    isSearched: false,                         // 塾検索済みかどうか
    clientCode: '',                            // お客様No照合時のお客様No
    lastOperatedDate: '',                      // 最終操作時間
    customer: cloneDeep(customerState),        // フォームの塾情報
    customerValid: true,                       // 塾情報に入力不備がないか
    classrooms: [cloneDeep(classroomState)],   // フォームの教室情報
    hasDuplicatedError: false,                 // 入力情報が全て重複している教室があるか
    classroomValid: true,                      // 教室情報に入力不備がないか
    registeredClassrooms: [],                  // 登録済み教室一覧
    selectedClassroomIds: [],                  // 解約対象の教室
    cancelForm: cloneDeep(cancelState)         // 解約フォーム
  },

  getters: {
    isNewCustomer(state) {
      return state.formComponent === 'NewCustomer'
    },
    isAddClassroom(state) {
      return state.formComponent === 'AddClassroom'
    },
    isCancelClassroom(state) {
      return state.formComponent === 'CancelClassroom'
    },
    isSearched(state, getters) {
      return !getters.isNewCustomer && state.customer.clientCode
    },
    disabledAddClassroom(state) {
      return state.classrooms.length >= 10
    },
    apiUrl(state, getters) {
      if (getters.isNewCustomer) return '/api/v1/enrollment/new_requests'
      else if (getters.isAddClassroom) return '/api/v1/enrollment/additional_requests'
      else if (getters.isCancelClassroom) return '/api/v1/enrollment/cancellation_requests'
      return ''
    }
  },

  mutations: {
    initialize(state) {
      state.formComponent = ''
      state.clientCode = ''
      state.lastOperatedDate = ''
      state.searchForm = cloneDeep(searchState)
      state.searchFormValid = true
      state.customer = cloneDeep(customerState)
      state.customerValid = true
      state.classrooms = [cloneDeep(classroomState)]
      state.hasDuplicatedError = false
      state.classroomValid = true
      state.registeredClassrooms = []
      state.selectedClassroomIds = []
      state.cancelForm = cloneDeep(cancelState)
    },
    initializeForm(state) {
      state.searchForm = cloneDeep(searchState)
      state.searchFormValid = true
      state.customer = cloneDeep(customerState)
      state.customerValid = true
      state.classrooms = [cloneDeep(classroomState)]
      state.hasDuplicatedError = false
      state.classroomValid = true
      state.registeredClassrooms = []
      state.selectedClassroomIds = []
      state.cancelForm = cloneDeep(cancelState)
    },
    setFormComponent(state, payload) {
      state.formComponent = payload.formComponent
    },
    setRegisteredClassrooms(state, payload) {
      state.registeredClassrooms = payload.branches
    },
    setCustomerPayload(state, payload) {
      Object.assign(state.customer, payload)
    },
    setClassroomPayload(state, payload){
      Object.assign(state.classrooms[payload.index], payload.classroom)
    },
    setSearchFormPayload(state, payload) {
      Object.assign(state.searchForm, payload)
    },
    setCancelFormPayload(state, payload) {
      Object.assign(state.cancelForm, payload)
    },
    addClassroom(state) {
      state.classrooms.push(cloneDeep(classroomState))
    },
    setHasDuplicatedError(state, payload) {
      state.hasDuplicatedError = payload.hasError
    },
    removeClassroom(state, payload) {
      state.classrooms.splice(payload.index, 1)
    },
    setCustomerValid(state, payload) {
      state.customerValid = payload.valid
    },
    setClassroomValid(state, payload) {
      state.classroomValid = payload.valid
    },
    setSearchFormValid(state, payload) {
      state.searchFormValid = payload.valid
    },
    setSelectedClassroomIds(state, payload) {
      state.selectedClassroomIds = payload.selectedClassroomIds
    },
    // お客様No照合
    setClientCode(state, payload) {
      state.clientCode = payload.clientCode;
    },
    // 最終操作時間更新
    setLastOperatedDate(state, payload) {
      state.lastOperatedDate = payload.lastOperatedDate;
    }
  },

  actions: {
    // 照合ボタンをクリックしてから30分経過したか
    async validateOperatedTime({ state }) {
      const currentDate = new Date().toLocaleString({ timeZone: 'Asia/Tokyo' })
      const diff = (new Date(currentDate) - new Date(state.lastOperatedDate)) / 1000
      return diff >= 1 * 60 * 30
    },
    async generateApiParams({ state, getters }) {
      let form = new FormData()
      // 新規申し込みの場合
      if (getters.isNewCustomer) {
        form.append('newRequest[startTime]', state.customer.startTime)
        form.append('newRequest[customerAttributes][code]', state.customer.clientCode)
        form.append('newRequest[customerAttributes][representative]', state.customer.enChargePerson)
        form.append('newRequest[customerAttributes][name]', state.customer.name)
        form.append('newRequest[customerAttributes][billing]', state.customer.invoiceType)
        form.append('newRequest[customerAttributes][postCode]', state.customer.postalCode)
        form.append('newRequest[customerAttributes][address]', state.customer.address)
        form.append('newRequest[customerAttributes][tel]', state.customer.tel)
        form.append('newRequest[customerAttributes][email]', state.customer.mail)
        if (state.customer.logoFilename) form.append('newRequest[customerAttributes][logo]', state.customer.logoFile)
        state.classrooms.forEach((c, index) => {
          form.append(`newRequest[customerAttributes][branchesAttributes][${index}][name]`, c.name)
          form.append(`newRequest[customerAttributes][branchesAttributes][${index}][tel]`, c.tel)
          form.append(`newRequest[customerAttributes][branchesAttributes][${index}][email]`, c.mail)
          form.append(`newRequest[customerAttributes][branchesAttributes][${index}][representative]`, c.chargePerson)
        })
      }

      // 教室追加申し込みの場合
      else if (getters.isAddClassroom) {
        const params = {
          additionalRequest: {
            customerId: state.customer.id,
            customerAttributes: {
              id: state.customer.id,
              branchesAttributes: state.classrooms.map(c => {
                return {
                  name: c.name,
                  tel: c.tel,
                  email: c.mail,
                  representative: c.chargePerson,
                  branchesRequestsAttributes: [{ start_time: c.startTime }]
                }
              })
            }
          }
        }
        form = params
      }

      // 解約申し込みの場合
      else if (getters.isCancelClassroom) {
        const params = {
          cancellationRequest: {
            customerId: state.customer.id,
            cancellationApplicant: state.cancelForm.name,
            cancellationRequestReasonsAttributes: state.cancelForm.selectedReason.map(sr => {
              return {
                cancellationReasonId: sr,
                otherDetail: sr === 7 ? state.cancelForm.message : ''
              }
            }),
          },
          branchIds: state.selectedClassroomIds.map(sc => sc.id)
        }
        form = params
      }

      return form
    },
  }
}
